import React, { useEffect, useState } from "react";
import styles from "./upcoming-exams.module.css";
import CustomCard from "../../../../components/custom-card/custom-card";
import GradientButton from "../../../../components/gradient-tick-button/gradient-tick-button";
import CustomTable from "../../../../common/custom-table/custom-table";
import { Spin } from "antd";
import { getExamList } from "../../../../services/examination";
import dayjs from "dayjs";
import { DATE_FORMAT, PAGE_LIMIT } from "../../../../constants/common";

const UpcomingExamsCard = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTableData([]);
    fetchExamList();
  }, []);

  const fetchExamList = async () => {
    try {
      setLoading(true);
      const payload = {
        page: 1,
        pageSize: PAGE_LIMIT,
        status: "Upcoming",
      };
      const resp = await getExamList(payload);
      const responceData = resp?.data;

      setTableData(responceData?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Exam Name",
      dataIndex: "exam_name",
      key: "exam_name",
      sorter: (a, b) => a.exam_name.localeCompare(b.exam_name),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Exam Type",
      dataIndex: "examination_type",
      key: "examination_type",
      sorter: (a, b) => a.examination_type.localeCompare(b.examination_type),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Exam Start Date",
      dataIndex: "exam_start_date",
      key: "exam_start_date",
      sorter: (a, b) => a.exam_start_date.localeCompare(b.exam_start_date),
      render: (text) => (
        <span style={{ cursor: "pointer" }}>
          {" "}
          {dayjs(text).format(DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY)}
        </span>
      ),
    },
    {
      title: "Exam End Date",
      dataIndex: "exam_end_date",
      key: "exam_end_date",
      sorter: (a, b) => a.exam_end_date.localeCompare(b.exam_end_date),
      render: (text) => (
        <span style={{ cursor: "pointer" }}>
          {dayjs(text).format(DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY)}
        </span>
      ),
    },
  ];

  return (
    <CustomCard style={{ height: 300 }}>
    
      <div className={styles.topBar}>
        <span className={styles.card_heading}>Upcoming Examinations</span>
        <div style={{ marginLeft: "auto" }}>
          <GradientButton />
        </div>
      </div>
    
      <div className={styles.tableWrapper}>
        <Spin spinning={loading}>
          <CustomTable
            columns={columns}
            dataSource={tableData}
            pagination={false}
          />
        </Spin>
      </div>
    </CustomCard>
  );
};

export default UpcomingExamsCard;
